/* ============================================================
   Enterprise AI on Proven Tech — tabbed technology grid

   All logo panels are static in HTML (one .tech-grid per tab,
   keyed by data-panel). This script simply hides/shows the
   matching panel and moves the glass indicator.
============================================================ */

export function initTechTabs() {
  var root = document.querySelector("[data-tech-tabs]");
  if (!root) return;

  var bar = root.querySelector(".tech-tabs-bar");
  var tabs = Array.prototype.slice.call(root.querySelectorAll(".tech-tab"));
  var panels = Array.prototype.slice.call(root.querySelectorAll("[data-panel]"));

  if (!bar || !tabs.length || !panels.length) return;

  function panelForKey(key) {
    return panels.find(function (panel) {
      return panel.getAttribute("data-panel") === key;
    });
  }

  function activeTab() {
    return root.querySelector(".tech-tab.is-active") || tabs[0];
  }

  function showPanel(key) {
    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute("data-panel") !== key;
    });
  }

  /* ----------------------------------------------------------
     Sliding active indicator
  ---------------------------------------------------------- */

  var indicator = document.createElement("span");
  indicator.className = "tech-tab-indicator";
  indicator.setAttribute("aria-hidden", "true");
  bar.appendChild(indicator);

  function moveIndicator(tab) {
    if (!tab) return;

    indicator.style.width = tab.offsetWidth + "px";
    indicator.style.height = tab.offsetHeight + "px";
    indicator.style.transform =
      "translate(" + tab.offsetLeft + "px," + tab.offsetTop + "px)";
  }

  moveIndicator(activeTab());
  bar.classList.add("has-indicator");

  /* Force initial position before enabling transition */
  void bar.offsetWidth;

  bar.classList.add("is-ready");

  /* ----------------------------------------------------------
     Tab selection
  ---------------------------------------------------------- */

  function selectTab(tab) {
    tabs.forEach(function (t) {
      var active = t === tab;

      t.classList.toggle("is-active", active);
      t.setAttribute("aria-selected", active ? "true" : "false");
      t.setAttribute("tabindex", active ? "0" : "-1");
    });

    moveIndicator(tab);
    showPanel(tab.getAttribute("data-tab"));
  }

  tabs.forEach(function (tab, index) {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      tab.blur();
      selectTab(tab);
    });

    tab.addEventListener("keydown", function (e) {
      var dir =
        e.key === "ArrowRight" || e.key === "ArrowDown"
          ? 1
          : e.key === "ArrowLeft" || e.key === "ArrowUp"
          ? -1
          : 0;

      if (!dir) return;

      e.preventDefault();

      var next = tabs[(index + dir + tabs.length) % tabs.length];

      next.focus();
      selectTab(next);
    });
  });

  /* ----------------------------------------------------------
     Keep indicator aligned
  ---------------------------------------------------------- */

  var raf;

  function reposition() {
    cancelAnimationFrame(raf);

    raf = requestAnimationFrame(function () {
      moveIndicator(activeTab());
    });
  }

  window.addEventListener("resize", reposition);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      moveIndicator(activeTab());
    });
  }

  /* ----------------------------------------------------------
     Initial state
  ---------------------------------------------------------- */

  showPanel(activeTab().getAttribute("data-tab"));
}